import React                            from 'react';
import { Observe }                      from 'rewire-core';
import {
  WithStyle,
}                                       from 'rewire-ui';
import { Theme }                        from '@material-ui/core/styles';
import { makeStyles, withStyles }       from '../utility/styles';
import ArchiveDeleteDialog              from './ArchiveDeleteDialog';
import archiveDeleteEmployeeDialogModel from './ArchiveDeleteEmployeeDialogModel';

const contentStyles = (_theme: Theme) => ({
  list: {
    listStylePosition: 'inside',
    textAlign: 'left',
    display: 'inline-block',
  },
});

const useContentStyles = makeStyles(contentStyles);

export const ArchiveDeleteEmployeeConfirmationContent = () => {
  const classes = useContentStyles();

  return <Observe render={() => {
    const employee    = archiveDeleteEmployeeDialogModel.name;
    const date        = archiveDeleteEmployeeDialogModel.endDateString;
    const taskDisplay = archiveDeleteEmployeeDialogModel.taskDisplay;
    return (
      < >
      <div>
        <div>
          All transactions for: {employee}<br />
          As of: {date} will be deleted from WorkSight for:
        </div>
        <ul className={classes.list}>
          <li>Timecards</li>
          <li>Jobs</li>
          <li>Time Off Requests</li>
          <li>Timecard Tests</li>
        </ul>
        <div>
          Enter Employee Name to Confirm {taskDisplay}:
        </div>
      </div>
      </>
    );
  }} />;
};

const styles = (_theme: Theme) => ({
});

interface IArchiveDeleteEmployeeDialogProps {
}

type ArchiveDeleteEmployeeDialogProps = WithStyle<ReturnType<typeof styles>, IArchiveDeleteEmployeeDialogProps>;

class ArchiveDeleteEmployeeDialog extends React.PureComponent<ArchiveDeleteEmployeeDialogProps> {
  constructor(props: ArchiveDeleteEmployeeDialogProps) {
    super(props);
  }

  render() {
    return <Observe render={() => (
      <ArchiveDeleteDialog model={archiveDeleteEmployeeDialogModel} />
    )} />;
  }
}

export default withStyles<IArchiveDeleteEmployeeDialogProps>(styles, ArchiveDeleteEmployeeDialog);
